import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-safra-detalhe',
  templateUrl: './safra-detalhe.component.html',
  styleUrls: ['./safra-detalhe.component.scss']
})
export class SafraDetalheComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
